import { AchievementData } from "./types"

export const achievementsSerializer = (data: any[]) => {
  return data.map((ach) => ({
    type: ach.type,
    name: ach.name,
    shortDescription: ach.short_description,
    fullDescription: ach.full_description,
    progressType: ach.progress_type,
    progressLimit: ach.progress_limit,
    currentProgress: ach.current_progress,
    receivedDate: ach.received_date,
    claimedDate: ach.claimed_date,
    isArchived: ach.is_archived
  })) as AchievementData[]
}

export function getCountEligibleAchievements(achievements: any): number {
  return achievements.filter(ach => ach.received_date !== null && ach.claimed_date === null).length;
}

const CATEGORY_PREFIXES = {
  conf_donations: 'conf_donations',
  donor_anniversary: 'donor_anniversary',
  double_donor: 'double_donor',
  kind_heart: 'kind_heart',
  new_year: 'new_year',
  recurring_payments: 'recurring_payments',
  referral_active_donors: 'referral_active_donors',
  regular_donor_: 'regular_donor',
  regular_donors_club: 'regular_donors_club',
  success_fundraising: 'success_fundraising',
  weekend_donor: 'weekend_donor',
};

export const getAchCategory = (type: string): string => {
  for (const prefix in CATEGORY_PREFIXES) {
    if (type.startsWith(prefix)) return CATEGORY_PREFIXES[prefix];
  }
  return 'base';
};